module.exports ={
    gateway: {
        operate:'Operation',
        add:'Add',
        edit:'Modify',
        del:'Delete',
        restart:'Restart',
        sure: 'OK',
        cancel: 'Cancel',
        attr:{
            name:'Name',
            macAddress:'MAC address',
            status:'Status',
            online:'在线',
            online1:'Online',
            offline:'离线',
            offline1:'Offline',
            lastUpdateTime:'Last update time',
            wifiVersion:'WiFi firmware version',
            bleVersion:'Ble firmware version',
            subModel: 'Model'
        },
        addTip: {
            success: 'Add gateway successfully',
            exist: 'The gateway already exist',
            fail: 'Adding the gateway failed',
            permission: 'You do not have permission to add gateway'
        },
        editTip:{
            success: 'Modify gateway successfully',
            exist: 'The gateway does not exist',
            fail: 'Modifying the gateway failed',
            permission: 'You do not have permission to modify gateway'
        },
        delTip:{
            success: 'Delete gateway successfully',
            exist: 'The gateway does not exist',
            fail: 'Deleting the gateway failed',
            msg:'Are you sure you want to delete {name}?',
            permission: 'You do not have permission to delete gateway'
        },
        restartTip:{
            success: 'The gateway is restarting, please wait a minutes to refresh page to get the lastest status',
            fail: 'Restarting the gateway failed',
            msg:'Are you sure you want to restart {name}?'
        },
        validMsg: {
            name:'Please enter name',
            nameLen:'The name must be less than 20 letters',
            mac:'Please enter mac address',
            macRule:'Please enter valid mac address',
            macExist: 'The gateway already exist',
            macFail: 'Failed to get, please re-enter'
        },
        wifiUpgrade: 'Wifi firmware upgrade',
        bleUpgrade: 'ble firmware upgrade',
        version: 'Firmware version',
        select: 'Please select',
        upgradeValidMsg: {
            id: 'Please select a version'
        },
        chooseVersion: 'Upgrade',
        upgradeTip: {
            getVersionfail: 'Upgrade version failed to get',
            success: 'Gateway {mac}: the firmware is being upgraded, please operate later',
            fail: 'Gateway {mac}: the gateway model does not match the firmware model and the upgrade fails',
            currentVersion: 'Gateway {mac}: the firmware is already in the required upgrade version',
            addFirst: 'Please select the gateway first',
            err: 'Upgrade failed',
            exist: 'Gateway {mac}: unable to get the model of the gateway, the upgrade failed',
            timeLimit: 'Do not perform frequent upgrades',
            unexist: 'Gateway {mac}: the gateway does not exist',
            offline: 'Gateway {mac}: The gateway is offline and cannot be upgraded',
            permission: 'You do not have permission to delete upgrade'
        },
        submiting: 'Submiting...'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/gateway.js